import { PaginationApiType } from '@shared/types/data-table.types';

export enum FrequencyValues {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export enum ExportType {
  IMMEDIATE = 'immediate',
  SCHEDULED = 'scheduled',
}

export enum ScheduledType {
  ONE_TIME = 'oneTime',
  RECURRING = 'recurring',
}

export enum ExportStatus {
  COMPLETED = 'completed',
  FAILED = 'failed',
  RUNNING = 'running',
  SCHEDULED = 'scheduled',
  CANCELLED = 'cancelled',
}

export interface Export {
  id: string;
  exportName: string;
  audienceName: string;
  exportType: ExportType;
  status: ExportStatus;
  scheduledType: ScheduledType | null;
  startedDate: Date | null;
  lastRun: Date | null;
  currentRuns: number;
  records: number;
  initiatedBy: string;
}

export interface GetExportsApiResponse {
  exports: Export[];
  pagination: PaginationApiType;
}
export interface ScheduledConfig {
  scheduleType: 'oneTime' | 'recurring';
  startDate: string;
  endDate: string | null;
  time: string;
  frequency: 'daily' | 'weekly' | 'monthly' | 'yearly' | null;
}

export interface ExportDestination {
  id: number;
  dataset: string;
  table: string;
  writePreference?: string;
  name?: string;
}

export interface ExportDestinationApiPayload {
  id: number;
  dataset: string;
  table: string;
  writePreference?: string;
}

export interface ExportField {
  id: number;
  label: string;
  required?: boolean;
  description?: string;
  type?: string[];
  categoryId?: number;
  sourceLabel?: string | undefined;
}

export interface CreateExport {
  audienceId: string;
  audienceName: string | null;
  fields: ExportField[];
  exportType: 'immediate' | 'scheduled';
  scheduledConfig: ScheduledConfig | null;
  exportName: string;
  destination: ExportDestination | null;
  nodes?: any[];
  edges?: any[];
}

export interface CreateExportApiPayload {
  audienceId: string;
  audienceName: string | null;
  fields: { id: number; sourceLabel: string | undefined }[];
  exportType: 'immediate' | 'scheduled';
  scheduledConfig: ScheduledConfig | null;
  exportName: string;
  destination: ExportDestinationApiPayload | null;
}

export interface StepperConfig {
  label: string;
  value: number;
}

export interface exportField {
  id: number;
  label: string;
  categoryId: number;
  required: boolean;
  sourceLabel: string | undefined;
}

export interface exportCategory {
  id: number;
  label: string;
}

export interface GetFieldsApiResponse {
  categories: exportCategory[];
  fields: exportField[];
}

export interface SearchedFieldItem {
  id: number;
  label: string;
  meta: string;
}

export interface SearchedFieldItemApiResponse {
  id: number;
  name: string;
  meta: string;
}

export interface SearchedFieldsApiResponse {
  label: string;
  value: string;
  items: SearchedFieldItemApiResponse[];
}

export interface SearchedFields {
  label: string;
  value: string;
  items: SearchedFieldItem[];
}
